<div class="above">
  <div class="search-paginator" [ngClass]="production === false ? 'color-search-paginator-pruebas': 'color-search-paginator-pro'">
    <div class="left-text">CONFIGURACION DE LA CAPACITACION /</div>

    <div class="search-controls">
      <input class="input-search" type="text" placeholder="Buscar..." (keyup)="searchFilterPagination($event.target.value)">

      <mat-paginator
        *ngIf="tableDataSourceTrainings"
        #paginatorTraining
        [length]="tableDataSourceTrainings.filteredData.length"
        [pageSize]="20"
        [pageSizeOptions]="[7, 15, 20]"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>

  <div class="training-config-container">
    <form [formGroup]="formTrainingType">
      <div class="planilla-information-training" [ngClass]="production === false ? 'planilla-pruebas': 'planilla-prod'" >
        <table class="config-table">
          <tr>
            <th><h3 class="field-table">NOMBRE DE LA CAPACITACION </h3></th>
            <th><h3 class="field-table">ORDEN DE PREGUNTAS</h3></th>
            <th><h3 class="field-table">APROBACION</h3></th>
            <th><h3 class="field-table">VINCULADO AL REQUISITO</h3></th>
            <th class="vigencia-header" colspan="1"><h3 class="field-table">VIGENCIA</h3></th>
            <th><h3 class="field-table">ALMACENAMIENTO</h3></th>
            <th><h3 class="field-table">ESTADO</h3></th>
            <th></th>
          </tr>
          <tr>
            <td><div class="field center">{{ dataTraining?.Name || 'N/A' }}</div></td>
            <td class="select-cell"><select formControlName="QuestionOrderType" class="select-center">
              <option [ngValue]="0">ALEATORIO</option>
              <option [ngValue]="1">NO ALEATORIO</option>
            </select></td>
            <td class="approval-cell"><input type="number" formControlName="ApprovalPercentage" min="0" max="100" class="input-small" /> <span class="percent-sign">%</span></td>
            <td class="select-cell">
              <div class="fields-group">
                <app-select-search-custom
                  class="selected" placeholder="Seleccionar Requisito"
                  [_dataSource]="requirementToSelect" [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="controlSearchRequirementSelect"
                  [disabled]="currentState !== 0" [allowClearSelection]="true"
                  [inputType]="'text'" (onSelectionChange)="changeRequirementSelect($event)"></app-select-search-custom>
              </div>
            </td>
            <td class="vigencia-td">
              <div class="vigencia-wrapper">
                <label class="blue-radio">
                  <input type="radio"  [attr.disabled]="byDateRestriction ? true : null" formControlName="ValidityType" [value]="2" />
                  <span>SIN VIGENCIA</span>
                </label>

                <label class="add-radio">
                  <input type="radio" formControlName="ValidityType" [value]="0" />
                  <span> SUMAR </span>
                </label>
                <input type="number" formControlName="ValidityMonths"
                       class="input-small"
                       min="1"  max="1200" placeholder="Meses"
                       (keydown)="preventInvalidInput($event)"
                       (input)="cleanInvalidValue($event)" autocomplete="off" />
                <span class="label-meses">Meses</span>

                <label class="fech-radio">
                  <input type="radio" formControlName="ValidityType" [value]="1" />
                  <span> FIN </span>
                </label>
                <div class="input-date-datetime">
                  <mat-form-field appearance="outline">
                    <input matInput type="datetime-local"  formControlName="ValidityEndDate"
                           style="max-width: 120px !important;
                           height: 15px !important;
                           display: flex;
                           flex-direction: column;
                           font-size: 14px !important;
                           letter-spacing: -1px !important;">
                  </mat-form-field>
                </div>
              </div>
            </td>
            <td style="width: 150px; font-weight: bold"><div class="field center"> {{ dataTraining?.TotalFileSizeMegaBytes || 0 }}
              &nbsp;/&nbsp; {{ maxStorageMb }} MB</div></td>
            <td style="width: 150px; font-weight: bold"><div class="field center">{{ dataTraining?.StateTranslation || 'N/A' }}</div></td>
            <td class="icon-cell" style="padding: 18px;">
              <button mat-fab class="save-fab" (click)="onSave()" [disabled]="currentState !== 0">
                <mat-icon>save</mat-icon>
              </button>
              <div class="btn-cancel">
                <button mat-mini-fab color="warn" (click)="onClose()" matTooltip="Cancelar configuracion de la capacitacion">
                  <mat-icon style="line-height: 21px !important;">cancel</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div class="plantilla-table" [ngClass]="production === false ? 'planilla-pruebas': 'planilla-prod'">
        <div class="mat-elevation-z8 "   [ngClass]="{'table-scroll-container': trainingListLength > 4}">
          <ng-container formArrayName="TrainingList">
            <table mat-table [dataSource]="tableDataSourceTrainings">
              <ng-container matColumnDef="Number">
                <th mat-header-cell class="header-table" *matHeaderCellDef style="width: 60px; min-width: 60px; text-align: center;">No</th>
                <td mat-cell *matCellDef="let formTraining; let i = index"  style="width: 60px; min-width: 60px; text-align: center;">
                  {{ i + 1 }}
                </td>
              </ng-container>
              <ng-container matColumnDef="ContextQuestion">
                <th mat-header-cell class="header-table" *matHeaderCellDef> Contexto de la pregunta </th>
                <td mat-cell class="header-table" *matCellDef="let formTraining">
                    <div class="DescContext" *ngIf="formTraining.get('ContextQuestion').value !== null && getMediaIcon(formTraining.get('ContextMediaType').value)"
                         (click)="openImgVideo(formTraining.get('ContextQuestion').value, formTraining.get('ContextMediaType').value)">
                      <mat-icon class="material-icons-outlined desc-icon">
                        {{ getMediaIcon(formTraining.get('ContextMediaType').value) }}
                      </mat-icon>
                    </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="Question">
                <th mat-header-cell class="header-table" *matHeaderCellDef> Texto Pregunta </th>
                <td mat-cell class="header-table" *matCellDef="let formTraining">
                  <div class="personal">
                    <div class="DescPersonal">
                      <div class="cell-text ">{{formTraining.get('Question').value}}</div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="CorrectAnswerImage">
                <th mat-header-cell class="header-table" *matHeaderCellDef>Imagen respuesta correcta</th>
                <td mat-cell class="header-table" *matCellDef="let formTraining">
                    <div class="DescContext">
                      <img class="img-answer" src="{{s3Bucket+getImg(formTraining.get('CorrectAnswerImage').value)}}" (error)="commonMetodService._getUrlErrorImg('noImage', $event)" alt="">
                    </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="CorrectAnswerText">
                <th mat-header-cell class="header-table" *matHeaderCellDef>Texto de respuesta correcta</th>
                <td mat-cell class="header-table" *matCellDef="let formTraining">
                  <div>
                    <div class="cell-text">{{formTraining.get('CorrectAnswerText').value}}</div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="ImageIncorrectAnswer">
                <th mat-header-cell class="header-table" *matHeaderCellDef>Imagen respuesta incorrecta</th>
                <td mat-cell class="header-table" *matCellDef="let formTraining">
                    <div class="DescContext">
                      <img class="img-answer-incorrect" src="{{s3Bucket+getImg(formTraining.get('ImageIncorrectAnswer').value)}}" (error)="commonMetodService._getUrlErrorImg('noImage', $event)" alt="">
                    </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="IncorrectAnswerText">
                <th mat-header-cell class="header-table" *matHeaderCellDef>Texto de respuesta incorrecta</th>
                <td mat-cell class="header-table" *matCellDef="let formTraining">
                    <div>
                      <div class="cell-text">{{formTraining.get('IncorrectAnswerText').value}}</div>
                    </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="Order">
                <th mat-header-cell class="header-table" *matHeaderCellDef style="width: 60px; min-width: 60px; text-align: center;">Orden</th>
                <td mat-cell class="header-table" *matCellDef="let formTraining" style="width: 60px; min-width: 60px; text-align: center;">
                  <div class="personal">
                    <div class="DescPersonal">
                      <div class="lablePersonal">{{formTraining.get('Order').value}}</div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef style="width: 60px; min-width: 60px; text-align: center;"> Acciones </th>
                <td mat-cell  *matCellDef="let formTraining" style="width: 90px; min-width: 60px; text-align: center;">
                  <button mat-icon-button [matMenuTriggerFor]="menuActions" [disabled]="currentState !== 0">
                    <mat-icon [ngStyle]="{color: currentState !== 0 ? '#9e9e9e' : 'rgb(106, 202, 37)'}"
                      style="width: 60px; min-width: 60px; text-align: center;">more_vert</mat-icon>
                  </button>
                  <mat-menu #menuActions="matMenu">
                    <button mat-menu-item style="color: rgb(106, 202, 37);" (click)="editQuestion(formTraining)">
                      <mat-icon style="color: rgb(106, 202, 37);">edit</mat-icon>
                      <span>Editar</span>
                    </button>
                    <button style="color: red;" mat-menu-item (click)="deleteQuestion(formTraining.get('IdQuestion').value)">
                      <mat-icon style="color: red;">delete</mat-icon>
                      <span>Eliminar</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columnsTraining"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsTraining;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No hay carnets disponibles</td>
              </tr>
            </table>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
    <div class="btn-container">
      <button type="button" class="create-button" [disabled]="currentState !== 0" (click)="onCreateQuestion()">CREAR PREGUNTA</button>
    </div>
</div>
